import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIntercomRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M6 10a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4z" }), /* @__PURE__ */ _jsx("path", {
		fill: "#f9f9f9",
		d: "M24 30a1 1 0 0 1-1-1V12a1 1 0 1 1 2 0v17a1 1 0 0 1-1 1m-6-1a1 1 0 0 1-1-1V13a1 1 0 1 1 2 0v15a1 1 0 0 1-1 1m12 0a1 1 0 0 1-1-1V13a1 1 0 1 1 2 0v15a1 1 0 0 1-1 1m6-2a1 1 0 0 1-1-1V15a1 1 0 1 1 2 0v11a1 1 0 0 1-1 1m-24 0a1 1 0 0 1-1-1V15a1 1 0 1 1 2 0v11a1 1 0 0 1-1 1m12 10.3a20 20 0 0 1-12.6-4.5 1 1 0 0 1 1.2-1.6 18 18 0 0 0 22.8 0 1 1 0 1 1 1.2 1.6A20 20 0 0 1 24 37.3"
	})]
});
export default SvgIntercomRegularIcon;
